import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { IdPropType } from '../../../proptypes/basic';
import FileTreeProvider from '../../files/components/FileTree/FileTreeProvider';
import Form from '../../form/components/Form';
import { updateEmailDraft, useEmailDraft } from '../emailDraftsSlice';
import { useCustomer } from '../../customers/customersSlice';
import {
    asAbsolutePath,
    attachmentsToFieldValue,
    fieldValueToAttachments,
    withPathDerivedName,
} from '../../files/utils';
import DropzoneFiles from '../../files/components/Dropzone/DropzoneFiles';
import SubmitButton from '../../form/components/SubmitButton';
import FormTouched from '../../form/components/FormTouched';

const MailDraftAttachments = ({ draftId }) => {
    const [draft] = useEmailDraft(draftId);
    const [customer] = useCustomer(draft?.customer_id);
    const cloudRoot = asAbsolutePath(customer?.cloudFolder);
    const dispatch = useDispatch();

    //console.log('MailDraftAttachments draft =>', draft);

    const initialValues = useMemo(
        () => ({
            attachments: attachmentsToFieldValue(
                (draft?.attachments || []).map(withPathDerivedName),
                [],
                'path',
                'name'
            ),
        }),
        [draft]
    );
    //console.log('MailDraftAttachments initialValues =>', initialValues);

    const handleSubmit = useCallback(
        ({ attachments }, { resetForm }) => {
            return dispatch(
                updateEmailDraft({ id: draftId, attachments: fieldValueToAttachments(attachments) })
            ).then(resetForm);
        },
        [dispatch, draftId]
    );

    return (
        <FileTreeProvider>
            <Form initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>

                {draft.attachments ? (
                    draft.customer_id ? (
                        <DropzoneFiles
                            name="attachments"
                            root={cloudRoot}
                            movable
                            openable
                            hideFiles
                            withNurseSearch
                        />
                    ) : (
                        <DropzoneFiles name="attachments" root={cloudRoot} openable hideFiles />
                    )
                ) : null}

                <FormTouched>
                    <SubmitButton />
                </FormTouched>
            </Form>
        </FileTreeProvider>
    );
};

MailDraftAttachments.propTypes = {
    draftId: IdPropType.isRequired,
};

MailDraftAttachments.defaultProps = {};

export default MailDraftAttachments;
